import gql from 'graphql-tag';
export const sendInvitation = gql`
mutation sendInvitation($input: SendInvitationInput) {
  sendInvitation(sendInvitationInput: $input)
}
`;
